export enum GameDifficulty {
	VERY_EASY = "VERY_EASY",
	EASY = "EASY",
	MEDIUM = "MEDIUM",
	HARD = "HARD",
	VERY_HARD = "VERY_HARD",
	HARD_CORE = "HARD_CORE",
}

export const GameDifficultyOptions = [
	{ value: GameDifficulty.VERY_EASY, label: "خیلی آسان", color: "bg-green-500 text-white" },
	{ value: GameDifficulty.EASY, label: "آسان", color: "bg-green-800 text-white" },
	{ value: GameDifficulty.MEDIUM, label: "متوسط", color: "bg-yellow-500 text-black" },
	{ value: GameDifficulty.HARD, label: "سخت", color: "bg-red-400 text-white" },
	{ value: GameDifficulty.VERY_HARD, label: "خیلی سخت", color: "bg-red-700 text-white" },
	{ value: GameDifficulty.HARD_CORE, label: "هاردکور", color: "bg-red-900 text-white" },
] as const;
